import Modal from "antd/lib/modal";

export default function CommonContainer({ children, visible, onCancel }) {
  return (
    <Modal footer={null} onCancel={onCancel} closable={false} centered visible={visible}>
      {children}
    </Modal>
  );
}
